import React, { useState, useEffect } from 'react';
import api from '../services/api';

const FormulierTemplatesBeheer = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);

  useEffect(() => { laad(); }, []);

  const laad = async () => {
    setLoading(true);
    try {
      const r = await api.get('/formulier-templates');
      setTemplates(r.data.data || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const nieuw = () => setEditing({
    naam: '', beschrijving: '', categorie: 'personeel',
    velden: [], email_naar: '', vereist_goedkeuring: false,
    zichtbaar_voor: 'iedereen', actief: true, volgorde: templates.length
  });

  const verwijder = async (t) => {
    if (!window.confirm(`Verwijder "${t.naam}"? Eerder ingediende invullingen blijven bestaan.`)) return;
    try {
      await api.delete('/formulier-templates/' + t.id);
      laad();
    } catch (e) { alert('Fout: ' + e.message); }
  };

  if (loading) return <div style={{ padding: 24, color: '#6b7280' }}>Laden...</div>;

  return (
    <div>
      <p style={{ margin: '0 0 16px', fontSize: 13, color: '#6b7280' }}>
        Definieer formulieren die medewerkers kunnen invullen. De ingevulde versie wordt automatisch als PDF gegenereerd en gemaild.
      </p>

      {templates.length === 0 ? (
        <div style={{ padding: 30, textAlign: 'center', color: '#9ca3af', background: '#f9fafb', borderRadius: 8 }}>
          Nog geen templates. Klik "+ Nieuw formulier".
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}>
          {templates.map(t => {
            const aantalVelden = Array.isArray(t.velden) ? t.velden.length :
                                 (typeof t.velden === 'string' ? JSON.parse(t.velden).length : 0);
            return (
              <div key={t.id} style={{
                background: 'white', border: '1px solid #e5e7eb', borderRadius: 8,
                padding: 14, display: 'flex', alignItems: 'center', gap: 12
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{t.naam}</div>
                  <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                    {aantalVelden} velden · {t.categorie}
                    {t.vereist_goedkeuring && ' · vereist goedkeuring'}
                    {!t.actief && ' · inactief'}
                  </div>
                </div>
                <button onClick={() => setEditing(t)}
                  style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 6, padding: '6px 12px', fontSize: 12, cursor: 'pointer' }}>
                  ✏️ Bewerken
                </button>
                <button onClick={() => verwijder(t)}
                  style={{ background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 6, padding: '6px 12px', fontSize: 12, cursor: 'pointer' }}>
                  🗑️
                </button>
              </div>
            );
          })}
        </div>
      )}

      <button onClick={nieuw}
        style={{ padding: '10px 18px', background: '#2563eb', color: 'white', border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>
        + Nieuw formulier
      </button>

      {editing && (
        <TemplateEditor template={editing} onClose={() => setEditing(null)} onSave={() => { setEditing(null); laad(); }} />
      )}
    </div>
  );
};

// ============================================================
const TemplateEditor = ({ template, onClose, onSave }) => {
  const isNieuw = !template.id;
  const [naam, setNaam] = useState(template.naam || '');
  const [beschrijving, setBeschrijving] = useState(template.beschrijving || '');
  const [categorie, setCategorie] = useState(template.categorie || 'personeel');
  const [velden, setVelden] = useState(
    Array.isArray(template.velden) ? template.velden :
    (typeof template.velden === 'string' ? JSON.parse(template.velden) : [])
  );
  const [emailNaar, setEmailNaar] = useState(template.email_naar || '');
  const [vereistGoedkeuring, setVereistGoedkeuring] = useState(template.vereist_goedkeuring || false);
  const [zichtbaarVoor, setZichtbaarVoor] = useState(template.zichtbaar_voor || 'iedereen');
  const [actief, setActief] = useState(template.actief !== false);
  const [kanVoorIemandAnders, setKanVoorIemandAnders] = useState(template.kan_voor_iemand_anders || false);
  const [planAutomatischIn, setPlanAutomatischIn] = useState(template.plan_automatisch_in || false);
  const [vereistSapBevestiging, setVereistSapBevestiging] = useState(template.vereist_sap_bevestiging || false);
  const [emailNaarExtra, setEmailNaarExtra] = useState(template.email_naar_extra || '');
  const [startDatumVeld, setStartDatumVeld] = useState(template.start_datum_veld || '');
  const [eindDatumVeld, setEindDatumVeld] = useState(template.eind_datum_veld || '');
  const [categorieIdVoorPlanning, setCategorieIdVoorPlanning] = useState(template.categorie_id_voor_planning || '');
  const [planCategorieen, setPlanCategorieen] = useState([]);

  useEffect(() => {
    api.get('/plan-categorieen').then(r => {
      setPlanCategorieen(r.data.data || []);
    }).catch(() => {});
  }, []);
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState('');

  const addVeld = () => setVelden([...velden, { naam: 'veld_' + (velden.length + 1), label: '', type: 'text', verplicht: false }]);
  const updateVeld = (i, k, v) => {
    const n = [...velden];
    n[i] = { ...n[i], [k]: v };
    setVelden(n);
  };
  const removeVeld = (i) => setVelden(velden.filter((_, idx) => idx !== i));

  const submit = async () => {
    setFout('');
    if (!naam) return setFout('Naam verplicht');
    if (velden.length === 0) return setFout('Voeg minstens 1 veld toe');
    for (const v of velden) {
      if (!v.naam || !v.label) return setFout('Elk veld heeft een naam en label nodig');
    }
    setBezig(true);
    try {
      const body = {
        naam, beschrijving, categorie, velden,
        email_naar: emailNaar || null,
        email_naar_extra: emailNaarExtra || null,
        vereist_goedkeuring: vereistGoedkeuring,
        zichtbaar_voor: zichtbaarVoor,
        actief,
        kan_voor_iemand_anders: kanVoorIemandAnders,
        plan_automatisch_in: planAutomatischIn,
        vereist_sap_bevestiging: vereistSapBevestiging,
        start_datum_veld: startDatumVeld || null,
        eind_datum_veld: eindDatumVeld || null,
        categorie_id_voor_planning: categorieIdVoorPlanning || null
      };
      if (isNieuw) await api.post('/formulier-templates', body);
      else await api.put('/formulier-templates/' + template.id, body);
      onSave();
    } catch (e) {
      setFout(e.response?.data?.message || e.message);
    } finally { setBezig(false); }
  };

  return (
    <div style={modalOverlay} onClick={onClose}>
      <div style={modalBox} onClick={e => e.stopPropagation()}>
        <h2 style={{ margin: '0 0 16px', fontSize: 20 }}>{isNieuw ? '+ Nieuw formulier' : 'Formulier bewerken'}</h2>

        <Field label="Naam *">
          <input value={naam} onChange={e => setNaam(e.target.value)} style={inputStyle} placeholder="Verlofaanvraag" />
        </Field>
        <Field label="Beschrijving">
          <textarea value={beschrijving} onChange={e => setBeschrijving(e.target.value)} rows={2} style={inputStyle} />
        </Field>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <Field label="Categorie">
            <select value={categorie} onChange={e => setCategorie(e.target.value)} style={inputStyle}>
              <option value="werk">Werk</option>
              <option value="veiligheid">Veiligheid</option>
              <option value="personeel">Personeel</option>
              <option value="klant">Klant</option>
            </select>
          </Field>
          <Field label="Zichtbaar voor">
            <select value={zichtbaarVoor} onChange={e => setZichtbaarVoor(e.target.value)} style={inputStyle}>
              <option value="iedereen">Iedereen</option>
              <option value="monteurs">Alleen monteurs</option>
              <option value="werkvoorbereider">Alleen werkvoorbereider</option>
            </select>
          </Field>
        </div>

        <Field label="E-mail naar (optioneel, krijgt kopie bij indienen)">
          <input type="email" value={emailNaar} onChange={e => setEmailNaar(e.target.value)} style={inputStyle} placeholder="hr@bedrijf.nl" />
        </Field>

        <div style={{ display: 'flex', gap: 16, marginBottom: 14 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
            <input type="checkbox" checked={vereistGoedkeuring} onChange={e => setVereistGoedkeuring(e.target.checked)} />
            Vereist goedkeuring
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
            <input type="checkbox" checked={actief} onChange={e => setActief(e.target.checked)} />
            Actief
          </label>
        </div>

        <Field label="Extra e-mailadressen (komma-gescheiden, krijgen ook kopie)">
          <input value={emailNaarExtra} onChange={e => setEmailNaarExtra(e.target.value)} style={inputStyle} placeholder="teamleider@bedrijf.nl, hr@bedrijf.nl" />
        </Field>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, marginBottom: 14 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
            <input type="checkbox" checked={kanVoorIemandAnders} onChange={e => setKanVoorIemandAnders(e.target.checked)} />
            Kan voor iemand anders ingediend worden (bv. ziekmelding door teamleider)
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
            <input type="checkbox" checked={planAutomatischIn} onChange={e => setPlanAutomatischIn(e.target.checked)} />
            Plan automatisch in kalender
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
            <input type="checkbox" checked={vereistSapBevestiging} onChange={e => setVereistSapBevestiging(e.target.checked)} />
            Vereist SAP-bevestiging vóór planning (verlofflow)
          </label>
        </div>

        {planAutomatischIn && (
          <div style={{ background: '#eff6ff', border: '1px solid #93c5fd', borderRadius: 8, padding: 12, marginBottom: 14 }}>
            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8, color: '#1e40af' }}>📅 Planning configuratie</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
              <Field label="Veldnaam voor startdatum">
                <input value={startDatumVeld} onChange={e => setStartDatumVeld(e.target.value)} placeholder="bv. start_datum" style={inputStyle} />
              </Field>
              <Field label="Veldnaam voor einddatum">
                <input value={eindDatumVeld} onChange={e => setEindDatumVeld(e.target.value)} placeholder="bv. eind_datum" style={inputStyle} />
              </Field>
            </div>
            <Field label="Categorie voor planning-tegel">
              <select value={categorieIdVoorPlanning} onChange={e => setCategorieIdVoorPlanning(e.target.value)} style={inputStyle}>
                <option value="">— Kies categorie —</option>
                {planCategorieen.map(c => <option key={c.id} value={c.id}>{c.titel} ({c.sap_code})</option>)}
              </select>
            </Field>
          </div>
        )}

        <h3 style={{ margin: '20px 0 10px', fontSize: 15 }}>📋 Velden</h3>
        {velden.map((v, i) => (
          <div key={i} style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 10, marginBottom: 8 }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 110px', gap: 8, marginBottom: 6 }}>
              <input value={v.label} onChange={e => updateVeld(i, 'label', e.target.value)} placeholder="Label (zichtbaar voor invuller)" style={smallInput} />
              <input value={v.naam} onChange={e => updateVeld(i, 'naam', e.target.value.replace(/[^a-z0-9_]/gi, '_').toLowerCase())} placeholder="veld_naam" style={smallInput} />
              <select value={v.type} onChange={e => updateVeld(i, 'type', e.target.value)} style={smallInput}>
                <option value="text">Tekst</option>
                <option value="textarea">Lange tekst</option>
                <option value="number">Getal</option>
                <option value="date">Datum</option>
                <option value="select">Keuzelijst</option>
              </select>
            </div>
            {v.type === 'select' && (
              <input
                value={(v.opties || []).join(', ')}
                onChange={e => updateVeld(i, 'opties', e.target.value.split(',').map(o => o.trim()).filter(Boolean))}
                placeholder="Opties, komma-gescheiden (bv. Vakantie, Bijzonder verlof)"
                style={{ ...smallInput, width: '100%', marginBottom: 6 }}
              />
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <label style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
                <input type="checkbox" checked={v.verplicht || false} onChange={e => updateVeld(i, 'verplicht', e.target.checked)} />
                Verplicht
              </label>
              <button onClick={() => removeVeld(i)} style={{ background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: 12 }}>🗑️ Verwijderen</button>
            </div>
          </div>
        ))}
        <button onClick={addVeld} style={{ background: '#f3f4f6', border: '1px dashed #d1d5db', borderRadius: 8, padding: '8px 14px', fontSize: 13, cursor: 'pointer', width: '100%' }}>
          + Veld toevoegen
        </button>

        {fout && <div style={errorStyle}>❌ {fout}</div>}

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
          <button onClick={onClose} disabled={bezig} style={btnSecondary}>Annuleren</button>
          <button onClick={submit} disabled={bezig} style={{ ...btnPrimary, opacity: bezig ? 0.6 : 1 }}>
            {bezig ? 'Opslaan...' : '💾 Opslaan'}
          </button>
        </div>
      </div>
    </div>
  );
};

const Field = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 4, color: '#374151' }}>{label}</label>
    {children}
  </div>
);

const inputStyle = { width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' };
const smallInput = { padding: '6px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' };
const modalOverlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' };
const modalBox = { background: 'white', borderRadius: 12, padding: 24, width: '100%', maxWidth: 640, maxHeight: '90vh', overflowY: 'auto' };
const errorStyle = { padding: '10px 14px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, fontSize: 13, color: '#dc2626', marginTop: 14 };
const btnPrimary = { padding: '10px 20px', background: '#2563eb', color: 'white', border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer' };
const btnSecondary = { padding: '10px 20px', background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 8, cursor: 'pointer' };

export default FormulierTemplatesBeheer;
